<mad-data-table
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [actions]="actions"
  [paginationEnabled]="true"
  [defaultPageSize]="10"
  [forceMode]="forceMode"
  (actionEvent)="handleActionEvent($event)"
>
</mad-data-table>
